/** @name 代码生成模版
 *  @param {String} data 格式化后的字符串
 *  @return {String} html文本内容
 *  @todo 修改 dialog-preview 组件的 previews 属性名
 *  @todo 修改引入组件的路径 src="./bundle.js" 为打包后的预览组件文件
 *  @author  王汝鹏
 *  @version 2019-09-23
 */
export default function (data) {
  return `<!DOCTYPE html>
  <html>
  <head>
    <meta charset="UTF-8">
    <link rel="stylesheet" href="https://web.allhome.com.cn/theme-chalk/index.css">
  </head>
  <body>
    <div id="app">

      <dialog-preview :previews="previews"></dialog-preview>

      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>
    <script src="https://cdn.jsdelivr.net/npm/vue@2.6.10/dist/vue.js"></script>
    <script src="https://web.allhome.com.cn/index.js"></script>
    <script src="./form_preview.js"></script>
    <script>
      new Vue({
        el: '#app',
        data: {
          previews: ${data},
        },
        methods: {
          handleSubmit () {
            // this.$refs.generateForm.getData().then(data => {
              // 数据校验成功
              // data 为获取的表单数据
            // }).catch(e => {
              // 数据校验失败
            // })
          }
        }
      })
    </script>
  </body>
  </html>`
}


// WEBPACK FOOTER //
// ./src/utils/generate_code.js